import React,{useEffect} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import CssBaseline from '@material-ui/core/CssBaseline';
import List from '@material-ui/core/List';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ArrowRight from '@material-ui/icons/ArrowRightAlt'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import { ExpandLess, ExpandMore } from '@material-ui/icons';
import { useNavigate } from "react-router-dom";
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import $ from "jquery";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
    },
    appBar: {

        marginLeft: 240,
    },
    drawer: {
        width: '100%',
        flexShrink: 0,
    },
    drawerPaper: {
        width: 100,
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        boxShadow: "none !important",
        border: "1px solid #F1F1F1",

    },
    // necessary for content to be below app bar
    toolbar: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.default,
        padding: theme.spacing(3),
    },
}));

const SidebarReport = () => {
    const classes = useStyles();
    const [open, setOpen] = React.useState(true);
    const [isMobile, setisMobile] = React.useState();
    const [value, setValue] = React.useState(0);
    const [more, setMore] = React.useState(true);
    const [less, setLess] = React.useState(true);
    const [plan, setPlan] = React.useState(true);
    const navigate = useNavigate();
    const SetActive1 = (e, str) => {
        $(".naviIcon").removeClass("d-block");
        $(".naviIcon").addClass("d-none");
        $("#" + str).removeClass("d-none");
        $("#" + str).addClass("d-block");
        $(".textNaviIcon .MuiListItemText-primary").removeClass("fw-bolder");
        $("#" + str + "1 .MuiListItemText-primary").addClass("spanTopBar");
        e === 1 ? navigate("/finalreport") : navigate("")
    }
    useEffect(() => {
        window.addEventListener('resize', resize);
        const interval = setInterval(() => {
            resize()
          }, 100);
          return () => clearInterval(interval);
    }, []);
    const resize = () => {
        if (window.innerWidth < 850) { setisMobile(true) }
        else { setisMobile(false) }
        $("#RE1 .MuiListItemText-primary").addClass("spanTopBar");
    };
    return (
        <>
         {isMobile ? 
            <div className={classes.root}>
                <CssBaseline />
                <List className="pt-4 mt-5 w-100 " style={{ backgroundColor: "#F6F6F6", height: "calc(100vh)", width: 240, bottom: 0 }} >
                <ListItem className='border-bottom' >
                        <ListItemText id={"RE" + "1"} className='pl-3 textNaviIcon' primary="Reports" />
                        <NavigateBeforeIcon id="RE" className="naviIcon ml-1" style={{ width: 23, height: 23 }} />
                        <Divider />
                    </ListItem>
                    {[ 'Final Report'].map((text, index) => (
                        <ListItem className="" button key={text} onClick={() => SetActive1(index + 1, text.replaceAll(" ", ""))}>
                            <ListItemText className="px-3 textNaviIcon" id={text.replaceAll(" ", "") + "1"} primary={text} />
                            <NavigateNextIcon className="naviIcon d-none" id={text.replaceAll(" ", "")} style={{ width: 23, height: 23 }} />
                        </ListItem>
                    ))}
                </List>
            </div>
            :navigate('/shiplist')}
        </>

    )
}
export default SidebarReport;